import { render, staticRenderFns } from "./CoreTag.vue?vue&type=template&id=2ba3d5c6&scoped=true&"
import script from "./CoreTag.vue?vue&type=script&lang=js&"
export * from "./CoreTag.vue?vue&type=script&lang=js&"
import style0 from "./CoreTag.vue?vue&type=style&index=0&id=2ba3d5c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba3d5c6",
  null
  
)

export default component.exports